const initialState = {
    isAuth: false,
    isOTP: false,
    isReg: false,
};

const Regflowreducer = (state = initialState, action) => {
	switch (action.type) {
		case "regFlowAuth":
			return {
				...state,
				isAuth: action.payload
			}
		case "regFlowOTP":
			return {
				...state,
				isOTP: action.payload
			}
		case "regFlowReg":
			return {
				...state,
				isReg: action.payload
			}
		default:
			return {
				...state,
			}
	}
}

export default Regflowreducer;